import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { FaClock, FaArrowRight } from 'react-icons/fa';
import '../styles/AssetUserRequestPending.css';

const AssetUserRequestPending = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const email = location.state?.email || sessionStorage.getItem('assetUserEmail') || 'your email';
  const [copied, setCopied] = useState(false);

  const handleCopyEmail = () => {
    navigator.clipboard.writeText(email);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="pending-container">
      <div className="pending-card">
        <div className="pending-icon">
          <FaClock />
        </div>

        <h1>Request Submitted Successfully!</h1>

        <div className="pending-message">
          <p>
            Your account registration request has been submitted and is now pending approval from the Lab Administrator.
          </p>

          <div className="request-details">
            <div className="detail-row">
              <span className="label">Email:</span>
              <span className="value">{email}</span>
              <button className="copy-btn" onClick={handleCopyEmail}>
                {copied ? 'Copied!' : 'Copy'}
              </button>
            </div>
          </div>

          <div className="info-box">
            <h3>What's Next?</h3>
            <ol>
              <li>A Lab Administrator will review your registration request</li>
              <li>You will receive an email notification once your request is approved or rejected</li>
              <li>Once approved, you can login using the email and password you provided</li>
            </ol>
          </div>

          <div className="timeline">
            <div className="timeline-item">
              <div className="timeline-circle active">
                <span>1</span>
              </div>
              <div className="timeline-content">
                <h4>Request Submitted</h4>
                <p>Your registration is pending review</p>
              </div>
            </div>

            <div className="timeline-line"></div>

            <div className="timeline-item">
              <div className="timeline-circle">
                <span>2</span>
              </div>
              <div className="timeline-content">
                <h4>Under Review</h4>
                <p>Admin is reviewing your request</p>
              </div>
            </div>

            <div className="timeline-line"></div>

            <div className="timeline-item">
              <div className="timeline-circle">
                <span>3</span>
              </div>
              <div className="timeline-content">
                <h4>Approval Complete</h4>
                <p>You can now login to your account</p>
              </div>
            </div>
          </div>
        </div>

        <div className="action-buttons">
          <button 
            className="btn-login"
            onClick={() => navigate('/asset-user-login')}
          >
            Go to Login <FaArrowRight />
          </button>
          <button 
            className="btn-back"
            onClick={() => navigate('/')}
          >
            Back to Home
          </button>
        </div>

        <div className="help-text">
          <p>
            <strong>Note:</strong> Please check your email for updates. 
            If you don't receive approval within 24 hours, please contact the Lab Administrator.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AssetUserRequestPending;
